import { createSlice } from "@reduxjs/toolkit";
import { UserDataResponse, authApi } from "../../services/auth";
import { RootState } from "../../store/store";

interface InitialState {
    user: UserDataResponse | null;
}
const initialState: InitialState = {
    user: null,
};

const slice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: () => {
            localStorage.removeItem("token");
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                authApi.endpoints.login.matchFulfilled,
                (state, action) => {
                    state.user = {
                        email: action.payload.email,
                        id: action.payload.id,
                        roles: action.payload.roles,
                    };
                }
            )
            .addMatcher(
                authApi.endpoints.register.matchFulfilled,
                (state, action) => {
                    state.user = {
                        email: action.payload.email,
                        id: action.payload.id,
                        roles: action.payload.roles,
                    };
                }
            )
            .addMatcher(
                authApi.endpoints.getCurUser.matchFulfilled,
                (state, action) => {
                    state.user = action.payload;
                }
            );
    },
});

export default slice.reducer;
export const { logout } = slice.actions;
export const selectUser = (state: RootState) => state.auth.user;
